import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { SelectedRange } from "@/types/data/redux.types";
import { schedulePowerApi } from "./services/powerApi";

export const setLiveRange = createAction<Omit<SelectedRange, "type">>(
  "scheduleExchange/setLiveRange"
);

// TODO: This async thunk is over-engineered and causes the websocket to be set up twice:
// 1. The thunk manually calls schedulePowerApi.endpoints.getWebsocketMessages.initiate(asset)
// 2. Power.tsx already has useGetWebsocketMessagesQuery(selectedResource) which auto-subscribes when selectedResource changes
// This should be simplified to a regular reducer action (like Energy page does with setSelectedResource).
// The RTK Query hook will automatically handle websocket init/cleanup when selectedResource changes.
export const setSelectedResource = createAsyncThunk(
  "scheduleExchange/setSelectedResource",
  async (asset: string, api) => {
    await api.dispatch(
      schedulePowerApi.endpoints.getWebsocketMessages.initiate(asset)
    );

    return asset;
  }
);
